import {
	ApiServiceHandler,
	EventBusInterceptor,
	UseService,
	type IApiServiceHandler
} from '@haskoning/js-api-authentication-management'

import API from '@/api/apiUrls'
import { useEventsBus } from '@haskoning/vue-component-library'
import type { Api as BaseStoreAPI } from '@haskoning/vue-basestore/dist/type/baseStore.type'

export type BaseItem = { id: number }

export const { emit } = useEventsBus()

const interceptor = new EventBusInterceptor(emit)

const baseURL = import.meta.env.VITE_APP_API_BASE_URL
const apiServiceHandler = new ApiServiceHandler(
	baseURL,
	API.TOKEN.ACCESS,
	API.TOKEN.REFRESH,
	interceptor
)

type Api<T extends BaseItem> = BaseStoreAPI<T> & {
	apiService: IApiServiceHandler
}

export const useApi = <T extends BaseItem>(): Api<T> => {
	return new UseService(apiServiceHandler) as unknown as Api<T>
}
